import { render, staticRenderFns } from "./PageDeleteAccount.vue?vue&type=template&id=e8057d9e&"
import script from "./PageDeleteAccount.vue?vue&type=script&lang=ts&"
export * from "./PageDeleteAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports